import LogoSVG from "../assets/Goe NG-logo/vector/default.svg";

export default function Navbar() {
  return (
    <div>
      <nav className="bg-white border-gray-200 dark:bg-gray-900">
        <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-4">
          <a href="#" className="flex items-center">
            <img src={LogoSVG} className="h-8 mr-3" alt="Flowbite Logo" />
            <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
              GeoNG
            </span>
          </a>
          <div className="flex items-center gap-x-6">
            <a
              href="https://www.npmjs.com/package/geo-ng"
              className="text-sm  text-blue-600 dark:text-blue-500 hover:underline"
            >
              NPM
            </a>
            <a
              href="https://github.com/Ayobamiu/geo-ng"
              className="text-sm  text-blue-600 dark:text-blue-500 hover:underline"
            >
              GitHub
            </a>
          </div>
        </div>
      </nav>
      {/* <nav className="bg-gray-50 dark:bg-gray-700">
        <div className="max-w-screen-xl px-4 py-3 mx-auto">
          <div className="flex items-center">
            <ul className="flex flex-row font-medium mt-0 mr-6 space-x-8 text-sm">
              <li>
                <a
                  href="#"
                  className="text-gray-900 dark:text-white hover:underline"
                  aria-current="page"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-900 dark:text-white hover:underline"
                >
                  Company
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-900 dark:text-white hover:underline"
                >
                  Team
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-900 dark:text-white hover:underline"
                >
                  Features
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav> */}
    </div>
  );
}
